import { render } from "./ChachItem.vue?vue&type=template&id=79199165"
import script from "./ChachItem.vue?vue&type=script&lang=js"
export * from "./ChachItem.vue?vue&type=script&lang=js"

import "./ChachItem.vue?vue&type=style&index=0&id=79199165&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__